import React from 'react';

export default function TopBar({ left, title, right, transparent = false }) {
    return (
        <div className="hb-topbar" style={{
            position: 'sticky', top: 0, zIndex: 10,
            display: 'flex', alignItems: 'center', justifyContent: 'space-between',
            padding: '12px 14px',
            paddingTop: 'calc(12px + env(safe-area-inset-top, 0px))',
            background: transparent ? 'transparent' : 'rgba(10,10,11,0.82)',
            backdropFilter: transparent ? 'none' : 'blur(18px) saturate(1.4)',
            WebkitBackdropFilter: transparent ? 'none' : 'blur(18px) saturate(1.4)',
            borderBottom: transparent ? 'none' : '1px solid #131316',
            minHeight: 52,
        }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, minWidth: 40 }}>
                {left}
            </div>
            {title && (
                <div style={{
                    position: 'absolute', left: '50%', transform: 'translateX(-50%)',
                    fontSize: 15, fontWeight: 600, color: '#fff', maxWidth: '55%',
                    textAlign: 'center', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
                }}>
                    {title}
                </div>
            )}
            <div style={{ display: 'flex', alignItems: 'center', gap: 4, minWidth: 40, justifyContent: 'flex-end' }}>
                {right}
            </div>
        </div>
    );
}

export const iconBtn = {
    background: 'transparent', border: 0, padding: 8,
    cursor: 'pointer', color: '#E4E4E7',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    borderRadius: 10,
};
